/* eslint-disable @typescript-eslint/camelcase */
import i18n from 'i18n';
import * as Yup from 'yup';

export default Yup.object().shape({
  email: Yup.string()
    .email(i18n.t('EMAIL_INVALID_KEY'))
    .required(i18n.t('REQUIRED_FIELD_KEY')),
  password: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
});
